import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React  from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


export default function Discipline() {// CHECKING IF USER IS VALID
  const [message, setMessage] = useState(false);
    const [discipline_code, setDisciplinecode] = useState("");
    const [discipline_name, setDisciplinename] = useState("");
    const [faculty_id, setFaculty_id] = useState("");
    const [faculty, setFacultyData] = useState([]);
    const [remarks, setRemarks] = useState("");
    const [errors, setErrors] = useState({ dcode: '', dname: '',fid: '' }); //20/3/2024 for validation
   
    const status = "active";

    const { http } = Api();
    const navigate = useNavigate();

    // CHECKING IF USER IS VALID
    const isAuth = useAuth()
    if (isAuth === false) {
      navigate("/admin/")
    }
  

    const validateForm = () => {
        

        const updatedErrors = {};
        let hasError = false;
    
        const faculty_id = document.getElementById('faculty_id').value;
        const displinecode = document.getElementById('discipline_code').value;
        const displinename = document.getElementById('discipline_name').value;
    
        if (!faculty_id) {
    
          updatedErrors.fid = 'Please enter a select Faculty';
          hasError = true;     
    
        }
        if (!displinecode) {
    
          updatedErrors.dcode = 'Please enter a Displine code';
          hasError = true;   
    
        }
        if (!displinename) {
          updatedErrors.dname = 'Please enter a Displine name';
          hasError = true; 
    
        }
        if (hasError) 
        {
          setErrors(updatedErrors);
          if (!faculty_id) {
              document.getElementById('faculty_id').focus();
          } else if (!displinecode) {
              document.getElementById('displinecode').focus();
          } else if (!displinename) {
            document.getElementById('displinename').focus();
          }
          return false;
       } else {
          setErrors({ dcode: '', dname: '',fid: '' });
          return true;
       }
    
       
    };
    useEffect(() => {

        const fetchData = async () => {
            try {
                const { http } = Api();
                const response = await http.get('/Admin/getfaculty');

                setFacultyData(response.data.data);

            } catch (error) {
                console.error('Error fetching faculty data:', error);
            }
        };

        fetchData();

    }, []);

    const cancelForm = () => {
        navigate("/admin/discipline");
    };

   
    const saveForm = (event) => {
        event.preventDefault();

        if (validateForm()) { 

            const remarksValue = remarks ? remarks : "Null";
            http.post('/Admin/savediscipline', { discipline_code: discipline_code, discipline_name: discipline_name,faculty_id:faculty_id, remarks: remarksValue, status: status  })
                .then(response => {

                    console.log(response.data);

                    if (response.data.status_code === "MSG1") {


                        sessionStorage.setItem("message", "New Discipline  Added Successfully");
                        navigate("/admin/discipline");

                    }
                })
                .catch(error => {
                    console.error(error);

                    if (error.response && error.response.status === 500) {
                        setMessage("Duplicate Value: This Discipline is already exists");
                    } else {
                        setMessage("Something Went Wrong");

                    }
                });
        }
    };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Discipline</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {/* {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )} */}
                    <div className="card-body pdg">
                      <div className="table-responsive">


                        <form className="form theme-form">
                          <div className="card-body custom-input">
                          
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Discipline Code <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <input type="text" className="form-control" id="discipline_code" name="discipline_code" placeholder="Discipline Code" onChange={(e) => setDisciplinecode(e.target.value)} maxLength={3} required ></input>
                                  {errors.dcode && <p className="text-danger">{errors.dcode}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Discipline Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <input type="text" className="form-control" id="discipline_name" name="discipline_name" placeholder="Discipline Name" onChange={(e) => setDisciplinename(e.target.value)} required ></input>
                                  {errors.dname && <p className="text-danger">{errors.dname}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Select Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={(e) => setFaculty_id(e.target.value)}  required>
                                        <option value="">Select Faculty</option>
                                        {faculty.map(facultys => (

                                            <option value={facultys.id}>{facultys.faculty_name}</option>
                                        ))}
                                    </select>
                                    {errors.fid && <p className="text-danger">{errors.fid}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Remarks</label>
                                  <div className="col-sm-9">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" onChange={(e) => setRemarks(e.target.value)} />
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </form>



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
